(function () {
  'use strict';

  angular
    .module('app.attendance-analytics')
    .service('attendanceAnalyticsService', attendanceAnalyticsService);

  /* @ngInject */
  function attendanceAnalyticsService($http, helperService) {
    /* jshint validthis: true */
    var vm = this;

    vm.quickview = quickview;
    vm.subjectGradeComparisons = subjectGradeComparisons;
    vm.teacherComparisons = teacherComparisons;
    vm.teacherDetails = teacherDetails;

    ////////////

    function quickview(filters) {
      // prepare filters

      return $http.get('/api/analytics/attendance-analytics/quickview', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }

    function subjectGradeComparisons(filters) {
      // prepare filters

      return $http.get('/api/analytics/attendance-analytics/subject-grade-comparisons', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }

    function teacherComparisons(filters) {
      // prepare filters

      return $http.get('/api/analytics/attendance-analytics/teacher-comparisons', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }

    function teacherDetails(filters) {
      // prepare filters

      return $http.get('/api/analytics/attendance-analytics/teacher-details', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }
  }
})();